<div class="hero-section">
    <app-menu-bar></app-menu-bar>
    <div class="overlay-content">
        <span class="title">{{ 'about_hero_title' | translate }}</span>
        <span class="subtitle">{{ 'about_hero_subtitle' | translate }}</span>
    </div>
</div>

<!-- Body copy mirrors fyes.gr/about-us: three sections, one paragraph each. -->
<section class="story-section">
    <div class="left">
        <img src="assets/images/homepage/about-us.jpg" alt="FYES" class="story-img">
    </div>
    <div class="right">
        <span class="title">{{ 'about_s1_title' | translate }}</span>
        <span class="description">{{ 'about_s1_text' | translate }}</span>
    </div>
</section>

<section class="technology-section">
    <div class="left">
        <span class="title">{{ 'about_s2_title' | translate }}</span>
        <span class="description">{{ 'about_s2_text' | translate }}</span>
    </div>
    <div class="right">
        <img src="assets/images/homepage/about-facility.jpg" alt="FYES facility" class="tech-img">
    </div>
</section>

<section class="values-section">
    <div class="left">
        <span class="title">{{ 'about_s3_title' | translate }}</span>
        <span class="description">{{ 'about_s3_text' | translate }}</span>
    </div>
    <div class="right">
        <img src="assets/images/homepage/about-partners.jpg" alt="FYES partners" class="values-img">
    </div>
</section>

<section class="final-section">
    <div class="banner">
        <span class="title">{{ 'about_final_title' | translate }}</span>
        <span class="description">{{ 'about_final_description' | translate }}</span>
        <div class="button-area">
            <button class="primary-btn" (click)="goToUrl('journey')">{{ 'about_final_cta' | translate }}</button>
            <span class="text">{{ 'about_final_questions' | translate }} <span class="highlight" (click)="goToUrl('contact')">{{ 'cta_contact_us' | translate }}</span></span>
        </div>
    </div>
</section>

<app-footer></app-footer>
